import React from 'react';
import { Link } from 'react-router-dom';
import { useLanguage } from '../../../contexts/LanguageContext';
import Navbar from '../../Layout/Navbar';
import Footer from '../../Layout/Footer';
import './Services.css';

const Services = () => {
  const { t } = useLanguage();
  
  return (
    <div className="services-page">
      <Navbar />
      
      <section className="page-hero">
        <div className="container">
          <h1>{t('services.pageTitle', 'Our Services')}</h1>
          <p>{t('services.pageSubtitle', 'Professional cleaning solutions for every need')}</p>
        </div>
      </section>

      <section className="services-overview">
        <div className="container">
          <div className="services-grid">
            <div className="service-card-large">
              <Link to="/services/private-cleaning" className="service-image-link">
                <div className="service-image-large">
                  <img src="https://images.unsplash.com/photo-1556911220-bff31c812dba?w=600&h=400&fit=crop" alt="Private Cleaning" />
                </div>
              </Link>
              <div className="service-content">
                <Link to="/services/private-cleaning" className="service-title-link">
                  <h2>{t('services.privateCleaning.title', 'Private Cleaning Services')}</h2>
                </Link>
                <p>
                  {t('services.privateCleaning.overview', 'Our private cleaning services are designed to keep your home spotless and comfortable. We offer regular maintenance cleaning, deep cleaning, and specialized services tailored to your needs. Our professional team uses eco-friendly products and proven techniques to ensure every corner of your home is thoroughly cleaned. Whether you need weekly, bi-weekly, or monthly service, we\'ll work with you to create a cleaning schedule that fits your lifestyle. From kitchens and bathrooms to living areas and bedrooms, we handle all the details so you can enjoy a clean, healthy living environment.')}
                </p>
                <Link to="/services/private-cleaning" className="service-link">{t('services.privateCleaning.readMore', 'Read More →')}</Link>
              </div>
            </div>

            <div className="service-card-large">
              <Link to="/services/commercial-cleaning" className="service-image-link">
                <div className="service-image-large">
                  <img src="https://images.unsplash.com/photo-1497366216548-37526070297c?w=600&h=400&fit=crop" alt="Commercial Cleaning" />
                </div>
              </Link>
              <div className="service-content">
                <Link to="/services/commercial-cleaning" className="service-title-link">
                  <h2>{t('services.commercialCleaning.title', 'Commercial Cleaning Services')}</h2>
                </Link>
                <p>
                  {t('services.commercialCleaning.overview', 'Maintain a professional and welcoming workspace with our comprehensive commercial cleaning services. We understand that a clean office environment is essential for productivity, employee satisfaction, and making a positive impression on clients. Our commercial cleaning services include daily office cleaning, restroom maintenance, floor care, window cleaning, and specialized services for different business types. We work around your business hours to minimize disruption and can customize our services to meet your specific industry requirements. Trust us to keep your business space immaculate and professional.')}
                </p>
                <Link to="/services/commercial-cleaning" className="service-link">{t('services.commercialCleaning.readMore', 'Read More →')}</Link>
              </div>
            </div>

            <div className="service-card-large">
              <Link to="/services/move-in-move-out" className="service-image-link">
                <div className="service-image-large">
                  <img src="https://images.unsplash.com/photo-1484154218962-a197022b5858?w=600&h=400&fit=crop" alt="Move-in/Move-out Cleaning" />
                </div>
              </Link>
              <div className="service-content">
                <Link to="/services/move-in-move-out" className="service-title-link">
                  <h2>{t('services.moveInMoveOut.title', 'Move-in/Move-out Cleaning Services')}</h2>
                </Link>
                <p>
                  {t('services.moveInMoveOut.overview', 'Moving can be stressful, but cleaning doesn\'t have to be. Our move-in/move-out cleaning services ensure your new home is move-in ready or that you leave your old place in pristine condition. We provide comprehensive deep cleaning that covers every detail, from scrubbing baseboards and cleaning inside appliances to washing windows and sanitizing all surfaces. This service is perfect for tenants who need to meet lease requirements, homeowners preparing to sell, or anyone moving into a new space. We\'ll make sure your property is thoroughly cleaned and ready for the next chapter, giving you peace of mind during your transition.')}
                </p>
                <Link to="/services/move-in-move-out" className="service-link">{t('services.moveInMoveOut.readMore', 'Read More →')}</Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};

export default Services;

